import { Table as Table$1 } from '@primer/react/experimental';
import sx from '../sx.js';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

const {
  Container: PrimerDataTableContainer,
  ...rest
} = Table$1;
const StyleDataTableContainer = styled(PrimerDataTableContainer).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "DataTable__StyleDataTableContainer",
  componentId: "sc-qy1ey2-0"
})(["", ""], sx);
function DataTableContainer({
  as,
  ...rest
}) {
  return /*#__PURE__*/jsx(StyleDataTableContainer, {
    ...rest,
    ...(as ? {
      forwardedAs: as
    } : {})
  });
}
const Table = Object.assign(Table$1, {
  Container: DataTableContainer,
  ...rest
});

export { Table };
